import { useTheme } from 'styled-components';
import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const FeeGe: React.FC<SvgIconDefaultProps> = ({ className, testId, color }) => {
  const { colors } = useTheme();

  const iconColor = color ? color : colors.interactive.brandColor;
  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.76367 2.5C4.66404 2.4982 4.56504 2.51626 4.47247 2.55314C4.3799 2.59002 4.2956 2.64498 4.2245 2.7148C4.15341 2.78463 4.09694 2.86792 4.05839 2.95981C4.01984 3.0517 3.99999 3.15035 4 3.25V18.75C4 20.2599 5.24011 21.5 6.75 21.5H17.25C18.7599 21.5 20 20.2599 20 18.75V3.25C20 3.12502 19.9688 3.00202 19.9092 2.89217C19.8496 2.78232 19.7635 2.68911 19.6587 2.621C19.5539 2.55288 19.4338 2.51204 19.3092 2.50216C19.1846 2.49229 19.0595 2.5137 18.9453 2.56446L16.9844 3.43653L14.7783 2.55371C14.5996 2.48232 14.4004 2.48232 14.2217 2.55371L12 3.44238L9.77832 2.55371C9.59964 2.48232 9.40036 2.48232 9.22168 2.55371L7.01562 3.43653L5.05469 2.56446C4.96297 2.52372 4.86401 2.5018 4.76367 2.5ZM7.25 8.5H16.75C17.165 8.5 17.5 8.835 17.5 9.25C17.5 9.665 17.165 10 16.75 10H7.25C6.835 10 6.5 9.665 6.5 9.25C6.5 8.835 6.835 8.5 7.25 8.5ZM7.25 13H12.75C13.165 13 13.5 13.335 13.5 13.75C13.5 14.165 13.165 14.5 12.75 14.5H7.25C6.835 14.5 6.5 14.165 6.5 13.75C6.5 13.335 6.835 13 7.25 13ZM15.75 13H16.75C17.165 13 17.5 13.335 17.5 13.75C17.5 14.165 17.165 14.5 16.75 14.5H15.75C15.335 14.5 15 14.165 15 13.75C15 13.335 15.335 13 15.75 13ZM7.25 16H12.75C13.165 16 13.5 16.335 13.5 16.75C13.5 17.165 13.165 17.5 12.75 17.5H7.25C6.835 17.5 6.5 17.165 6.5 16.75C6.5 16.335 6.835 16 7.25 16ZM15.75 16H16.75C17.165 16 17.5 16.335 17.5 16.75C17.5 17.165 17.165 17.5 16.75 17.5H15.75C15.335 17.5 15 17.165 15 16.75C15 16.335 15.335 16 15.75 16Z"
        fill={iconColor}
      />
    </CustomSvg>
  );
};

export default FeeGe;
